import { Flex } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 8px;
`;

export const Content = styled(Flex).attrs({
  align: 'center',
  justify: 'space-between',
})`
  padding: 5px 12px;
`;

export const CheckboxesWrapper = styled(Flex).attrs({
  gap: 8,
  vertical: true,
})`
  flex-wrap: wrap;
`;

export const ButtonsWrapper = styled(Flex).attrs({
  gap: 8,
  align: 'center',
  justify: 'space-between',
})`
  margin-top: 8px;
  width: 100%;
`;
